import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentQuestionIndex: 0,
  answers: {},
  timeLeft: null,
  endExam: true,
}

const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    setCurrentQuestionIndex: (state, action) => {
      state.currentQuestionIndex = action.payload
    },
    setAnswer: (state, action) => {
      const { questionId, answer } = action.payload
      state.answers[questionId] = answer
    },
    setEndExam: (state, action) => {
      state.endExam = action.payload
    },
    decrementTime: (state) => {
      if (state.timeLeft > 0) {
        state.timeLeft -= 1
        state.endExam = false
      }
      //  else {
      //   state.currentQuestionIndex = 0
      //   state.answers = {}
      //   state.timeLeft = null
      //   state.endExam = true
      // }
    },
    setTimeLeft: (state, action) => {
      state.timeLeft = action.payload
    },
    clearExtraReducers: (state) => {
      state.currentQuestionIndex = 0
      state.answers = {}
      state.timeLeft = null
      state.endExam = true
    },
  },
})

export const { setCurrentQuestionIndex, setAnswer, decrementTime, setTimeLeft } = examSlice.actions
export default examSlice.reducer
